import { createFileRoute } from '@tanstack/react-router';
import { FileText, Table } from 'lucide-react';
import { CycleReportCard, DataExportCard } from '@/components/reports';
import { RoleGuard } from '@/components/layout/RoleGuard';

export const Route = createFileRoute('/_app/reports')({
  component: () => (
    <RoleGuard allowedRoles={['owner', 'operator']}>
      <ReportsPage />
    </RoleGuard>
  ),
});

function ReportsPage() {
  return (
    <div className="space-y-6">
      {/* Page Header */}
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Reports</h1>
        <p className="mt-1 text-sm text-gray-500">
          Generate PDF reports and export data for analysis
        </p>
      </div>

      {/* Report Types */}
      <div className="grid gap-6 lg:grid-cols-2">
        {/* PDF Reports */}
        <div className="space-y-4">
          <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
            <FileText className="h-5 w-5 text-primary-500" />
            PDF Reports
          </h2>
          <CycleReportCard />
        </div>

        {/* Data Exports */}
        <div className="space-y-4">
          <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
            <Table className="h-5 w-5 text-green-500" />
            Data Exports
          </h2>
          <DataExportCard />
        </div>
      </div>
    </div>
  );
}
